import * as S from "../ConvenienceTest.style";
import ConvenienceTestAccountHolderDataInputs from "./ConvenienceTestAccountHolderDataInputs";
import { useHistory } from "react-router-dom";
import { useState, useEffect, useCallback, useContext } from "react";
import Auth from "../../../Auth/Auth";
import UserIdentitiesService, {
  JobDto,
  UserIdentityAccessRequest,
  UserIdentityJobsResponse,
  UserIdentityType,
} from "../../../services/UserIdentitiesService";
import "./dropDown.css";
import { useParams } from "react-router-dom";
import { DefaultButton, Spinner, SpinnerSize } from "@fluentui/react";
import scrollToTop from "../../../utils/scrollToTop";
import SavingsPlanService, {
  SavingsPlanType,
} from "../../../services/SavingsPlanService";
import React from "react";
import DocumentTitle from "react-document-title";
import { ThemeContext } from "@fluentui/react-theme-provider";
import moment from "moment";
import { DEFATULT_WARNING_MESSAGE } from "./AuthorizationConstants";
import TicketSupport from "../../TicketSupport/TicketSupport";
import TicketSupportService, {
  TicketSupportData,
} from "../../../services/TicketSupportService";
import { ModalWithCancel } from "../../Modals/ModalWithCancel";
import FinancialData from "../../IntervinentForm/FinancialData/FinancialData";
import ClaimMessage from "./ClaimMessage/ClaimMessage";
import {
  ClaimMessageData,
  ClaimMessageType,
} from "./ClaimMessage/ClaimMessageType";
import { UserIndentityStatusEnum } from "../../types/UserIdentity.Status";
import FinametrixService from "../../../services/FinametrixService";

interface SelectOption {
  key: string;
  text: string;
  name: string;
}

const SCREEN_NAME = "Formulario de altas";
const ConvenienceTestAccountHolderData = () => {
  const history = useHistory();
  const user = Auth.getUserProfile();
  const theme = useContext(ThemeContext);
  const [canSubmit, setCanSubmit] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState({ status: false, message: "" });
  const { savingsPlanId } = useParams<any>();
  const { userIdentityId } = useParams<any>();
  const { mode } = useParams<any>();
  const [savingsPlan, setSavingsPlan] = useState<SavingsPlanType>();
  const [isLoadedUserIdentity, setIsLoadedUserIdentity] = useState(false);
  const [userIdentity, setUserIdentity] = useState<any>();
  const [financialUserIdentity, setFinancialUserIdentity] = useState<any>({
    economicActivity: null,
    proofOfIncome: null,
    gafiQuestion: false,
    publicPosition: false,
    maxContribution: null,
  });
  const [userIdentities, setUserIdentities] = useState<UserIdentityType[]>();
  const [sameAddress, setSameAddress] = useState<boolean>(false);
  const [isMinor, setIsMinor] = useState<boolean>(false);

  // nextportfolio
  const finametrixIdRef = React.useRef<string>("");
  // isMinor
  const isMinorRef = React.useRef<boolean>(false);
  // información finaciera
  const [showFinancialForm, setShowFinancialForm] = useState<boolean>(false);
  // stickyheader
  const [isSticky, setIsSticky] = useState(false);
  // jobs
  const [jobs, setJobs] = useState<SelectOption[]>([]);
  // error claim
  const AUTO_DISMISS_TYPES: ClaimMessageType[] = ["success"];
  const [documentLoaded, setDocumentLoaded] = useState(false);
  const [pendingClaims, setPendingClaims] = useState<ClaimMessageData[]>([]);
  const [claimMessages, setClaimMessages] = useState<ClaimMessageData[]>([]);

  // access-request de intervinientes
  const isNewUserIdentity = !userIdentityId;
  const [userIdentityByIdDocument, setUserIdentityByIdDocument] =
    useState<UserIdentityType | null>(null);
  const [isSendingAuthorization, setIsSendingAuthorization] =
    useState<boolean>(false);
  const [blockedByAuthorizationWarning, setBlockedByAuthorizationWaring] =
    useState<boolean>(false);

  // ticket soporte + modal
  const [showSupportForm, setShowSupportForm] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalBody, setModalBody] = useState("");
  const MODAL_TITLE_ERROR = "Error al enviar el ticket de soporte";
  const MODAL_BODY_ERROR =
    "Ocurrió un error al procesar tu solicitud. Por favor, inténtalo de nuevo más tarde.";
  const MODAL_TITLE_SUCCESS = "Ticket de soporte enviado.";
  const PARTIAL_MODAL_BODY_SUCCESS =
    "creado correctamente. Intentaremos solucionar tu problema lo antes posible.";

  // -------------------------------------------------------------------
  // Ticket soporte
  // -------------------------------------------------------------------
  const handleSupportSend = async (ticketData: TicketSupportData) => {
    try {
      const response = await TicketSupportService.createNewSupportTicket(
        ticketData
      );
      setModalTitle(`${MODAL_TITLE_SUCCESS}`);
      setModalBody(
        `Ticket con referencia: ${response.Id!} ${PARTIAL_MODAL_BODY_SUCCESS}`
      );
    } catch (error) {
      console.error(`${MODAL_TITLE_ERROR} : ${error}`);
      setModalTitle(`${MODAL_TITLE_ERROR}`);
      setModalBody(`${MODAL_BODY_ERROR}`);
    } finally {
      setShowModal(true);
    }
  };

  // -------------------------------------------------------------------
  // ClaimMessage: error claim
  // -------------------------------------------------------------------
  // Añade mensaje a claimMessages evitando duplicados
  const addClaimMessage = (claim: ClaimMessageData) => {
    setClaimMessages((prev) => {
      if (prev.some((c) => c.id === claim.id)) return prev;
      return [...prev, claim];
    });

    if (AUTO_DISMISS_TYPES.includes(claim.type)) {
      setTimeout(() => {
        removeClaimMessage(claim.id);
      }, 5000);
    }
  };

  // Elimina mensaje del estado correcto según si documento cargado o no
  const removeClaimMessage = (id: string) => {
    if (!documentLoaded) {
      setPendingClaims((prev) => prev.filter((c) => c.id !== id));
    } else {
      setClaimMessages((prev) => prev.filter((c) => c.id !== id));
    }
  };

  // Maneja agregar o eliminar mensajes según estado del documento
  const handleClaimMessage = (
    claim: ClaimMessageData | null,
    idToRemove?: string
  ) => {
    if (claim) {
      if (!documentLoaded) {
        setPendingClaims((prev) => {
          if (prev.some((c) => c.id === claim.id)) return prev;
          return [...prev, claim];
        });
      } else {
        addClaimMessage(claim);
      }
    } else if (idToRemove) {
      removeClaimMessage(idToRemove);
    }
  };

  const onHandleFinancialClaimMessage = (
    claim: ClaimMessageData | null,
    idToRemove?: string
  ) => {
    if (claim) {
      addClaimMessage(claim);
    } else if (idToRemove) {
      removeClaimMessage(idToRemove);
    }
  };

  // Cuando el documento se carga, pasamos los mensajes pendientes a activos
  useEffect(() => {
    if (documentLoaded && pendingClaims.length > 0) {
      setClaimMessages((prev) => {
        const newClaims = pendingClaims.filter(
          (pc) => !prev.some((c) => c.id === pc.id)
        );
        return [...prev, ...newClaims];
      });
      setPendingClaims([]); // Limpiamos los pendientes
    }
  }, [documentLoaded, pendingClaims]);

  // access-request: edición y visualización
  const [showAuthorizationWarning, setShowAuthorizationWarning] =
    useState<boolean>(false);
  const [userIdentityForm, setUserIdentityForm] = useState<any>({
    firstName: false,
    lastName: false,
    email: false,
    operationCountryPrefix: true,
    countryPrefix: true,
    operationPhone: false,
    phone: false,
    birthday: true,
    idDocument: false,
    proofOfMinorGuardianDescription: true,
    postal_streetName: true,
    postal_streetNumber: true,
    postal_zipCode: false,
    idExpiration: false,
    nationalCountry: false,
    fiscal_streetName: true,
    fiscal_streetNumber: true,
    fiscal_zipCode: true,
    idFront: false,
    idBack: false,
    financialData: false,
  });

  // información financiera
  const [financialForm, setFinancialForm] = useState<any>({
    economicActivity: false,
    proofOfIncome: false,
    gafiQuestion: false,
    publicPosition: false,
    maxContribution: false,
  });

  // autorization
  const [authorizationWarningMessage, setAuthorizationWarningMessage] =
    useState<string>(DEFATULT_WARNING_MESSAGE);
  const [showAuthorizationButton, setShowAuthorizationButton] =
    useState<boolean>(true);

  // estado de acceso al userIdentity / modos
  const [isOnlyView, setIsOnlyView] = useState<boolean>(false);
  const [accessMode, setAccessMode] = useState<"edit" | "view" | null>(null);

  useEffect(() => {
    scrollToTop();
  }, []);

  /*************************************************************************************
   * CARGAR JOBS: Recuperar los trabajos del usuario para select de ACTIVIDAD ECONÓMICA
   *************************************************************************************/
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const jobsData: UserIdentityJobsResponse =
          await UserIdentitiesService.getJobs();

        if (jobsData.count > 0) {
          const transformed: SelectOption[] = jobsData.jobs.map(
            (job: JobDto) => ({
              key: job.clave.toString(),
              text: job.descripcion,
              name: job.descripcion,
            })
          );

          setJobs(transformed);
        }
      } catch (error) {
        console.error("Error al cargar los trabajos:", error);
      } finally {
        // setShowFinancialForm(true); // Mostrar el formulario financiero por defecto
      }
    };

    fetchJobs();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsSticky(scrollTop > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /**********************************************************************************
   * ACCESS-REQUEST: Comprobar si el usuario tiene permisos de edición o visualización
   **********************************************************************************/
  useEffect(() => {
    if (!userIdentityId || !user?.id) return;

    const fetchAccessControl = async () => {
      try {
        const response = await UserIdentitiesService.getAccessRequestMode(
          user.id,
          userIdentityId
        );
        setAccessMode(response.mode as "edit" | "view");
        setError({ status: false, message: "" });

        // Si URL dice 'edit' pero backend dice 'view', redirige a 'view'
        if (mode === "edit" && response.mode === "view") {
          history.replace(
            `/accountHolderData/${savingsPlanId}/${userIdentityId}/view`
          );
        }
        setIsOnlyView(response.mode === "view");
      } catch (err: any) {
        setError({
          status: true,
          message:
            err.message ||
            "Ha ocurrido un error. Inténtelo de nuevo más tarde.",
        });
        setAccessMode("view");
        setIsOnlyView(true);
      }
    };

    fetchAccessControl();
  }, [userIdentityId, user?.id, mode, history, savingsPlanId]);

  /**********************************************************************************
   * SAME ADDRESS: Actualizar el estado de userIdentityForm
   **********************************************************************************/
  useEffect(() => {
    if (sameAddress) {
      // PASO 1:: si cambia el toggle de sameAddress, se actualiza el estado de userIdentityForm
      setUserIdentityForm((prevState: any) => {
        return {
          ...prevState,
          fiscal_streetName: false,
          fiscal_streetNumber: false,
          fiscal_zipCode: false,
        };
      });
    } else {
      setUserIdentityForm((prevState: any) => {
        return {
          ...prevState,
          fiscal_streetName: true,
          fiscal_streetNumber: true,
          fiscal_zipCode: true,
        };
      });
    }
  }, [sameAddress]);

  /********************************************************************************************
   * CARGAR USER IDENTITIES: Recuperar las identidades del usuario y el userIdentity específico
   ********************************************************************************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userIdentities =
          await UserIdentitiesService.getIdentitiesByUserId(user.id);
        setUserIdentities(userIdentities);

        if (userIdentityId) {
          // Si se pasa un userIdentityId específico, lo recuperamos directamente
          const userIdentity = await UserIdentitiesService.getUserIdentity(
            userIdentityId
          );
          setUserIdentity(userIdentity);
          const isCurrentMinor =
            moment().diff(moment(userIdentity.birthday), "years") < 18;

          if (isCurrentMinor) {
            setIsMinor(true);
            setShowFinancialForm(false);
            isMinorRef.current = true;
            setFinancialUserIdentity({
              economicActivity: null,
              proofOfIncome: null,
              gafiQuestion: false,
              publicPosition: false,
              maxContribution: 0,
            });
          } else {
            setIsMinor(false);
            isMinorRef.current = false;
            // setShowFinancialForm(true);
            setFinancialUserIdentity({
              economicActivity: userIdentity.economicActivity,
              proofOfIncome: userIdentity.proofOfIncome,
              gafiQuestion: userIdentity.gafiQuestion,
              publicPosition: userIdentity.publicPosition,
              maxContribution: userIdentity.maxContribution || 0,
            });

            setShowFinancialForm(true);
          }
        } else if (
          userIdentities.length === 1 &&
          userIdentities[0].updatedAt === null
        ) {
          // Caso de único UserIdentity no actualizado aún
          setUserIdentity(userIdentities[0]);
          setFinancialUserIdentity({
            economicActivity: userIdentities[0].economicActivity,
            proofOfIncome: userIdentities[0].proofOfIncome,
            gafiQuestion: userIdentities[0].gafiQuestion,
            publicPosition: userIdentities[0].publicPosition,
            maxContribution: userIdentities[0].maxContribution || 0,
          });
        } else {
          // Crear uno nuevo vacío
          setUserIdentity({
            firstName: "",
            lastName: "",
            birthday: "",
            email: "",
            countryPrefix: "+34",
            phone: "",
            operationCountryPrefix: "+34",
            birthdayCountry: "ES",
            nationalCountry: "ES",
            finametrixId: finametrixIdRef.current,
            operationPhone: "",
            userId: user.id,
            status: "NEW",
            fiscalAddress: null,
            sameAddress: !!sameAddress,
            main: false,
            idFront: null,
            idBack: null,
            idType: "DNI",
            fnmContractsUserIdentities: [],
            gafiQuestion: false,
            publicPosition: false,
            economicActivity: null,
            proofOfIncome: null,
            maxContribution: null,
          });

          setFinancialUserIdentity({
            economicActivity: null,
            proofOfIncome: null,
            gafiQuestion: false,
            publicPosition: false,
            maxContribution: null,
          });
        }
      } catch (error: any) {
        setError(error);
      }
    };

    if (user?.id) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userIdentityId]);

  /*******************************************
   * CARGAR SAVINGS PLAN por el savingsPlanId
   *******************************************/
  useEffect(() => {
    if (savingsPlanId !== undefined) {
      SavingsPlanService.getSavingsPlan(savingsPlanId).then(
        (savingPlan: any) => {
          setSavingsPlan(savingPlan);
        },
        (error: any) => {
          setError(error);
        }
      );
    }
  }, [savingsPlanId]);

  /*******************************************
   * USER IDENTITY
   *******************************************/
  useEffect(() => {
    if (userIdentity !== undefined) {
      setIsLoadedUserIdentity(true);
      setDocumentLoaded(true);
    }
  }, [userIdentity]);

  // --------------------------------------------------------------------------
  // HANDLERS: Actualizar los datos del formulario de identidad del usuario
  // --------------------------------------------------------------------------
  const handleAccountHolderDataChange = (event: any) => {
    let { name, value }: { name: string; value: string } = event.target;
    let realValue = value;
    if (
      event.target.files !== null &&
      event.target.files !== undefined &&
      event.target.files.length > 0
    ) {
      realValue = event.target.files[0];
    }
    setUserIdentity((prevState: any) => ({
      ...prevState,
      [name]: realValue,
    }));
  };

  // --------------------------------------------------------------------------
  // HANDLERS: Actualizar los datos financieros del interviniente
  // --------------------------------------------------------------------------
  const handleFinancialDataChange = (event: any) => {
    const { name, value } = event.target;

    let realValue: any = value;
    if (value === true || value === false) {
      realValue = value;
    } else if (value === "true") {
      realValue = true;
    } else if (value === "false") {
      realValue = false;
    }

    if (name === "maxContribution") {
      realValue = Number(value);
    }

    if (event.target.files && event.target.files.length > 0) {
      realValue = event.target.files[0];
    }

    setFinancialUserIdentity((prevState: any) => ({
      ...prevState,
      [name]: realValue,
    }));
  };

  const handlePostalAddressAccountHolderDataChange = (event: any) => {
    let { name, value }: { name: string; value: string } = event.target;
    let realValue = value;
    const realName = name.trim().startsWith("postal_")
      ? name.trim().slice(7)
      : name;

    if (
      event.target.files !== null &&
      event.target.files !== undefined &&
      event.target.files.length > 0
    ) {
      realValue = event.target.files[0];
    }

    setUserIdentity((prevState: any) => ({
      ...prevState,
      postalAddress: {
        ...prevState.postalAddress,
        [realName]: realValue,
      },
    }));
  };

  const handleAccountHolderSameAddressChange = (event: any) => {
    var { checked }: { name: string; checked: boolean } = event.target;
    setSameAddress(!checked);
    setUserIdentity((prevState: any) => ({
      ...prevState,
      sameAddress: checked,
    }));
  };

  useEffect(() => {
    if (isMinor) {
      setUserIdentityForm((prevState: any) => {
        return {
          ...prevState,
          email: true,
          operationPhone: true,
          phone: true,
          proofOfMinorGuardianDescription:
            userIdentity.proofOfMinorGuardianDescription !== undefined
              ? true
              : false,
          financialData: true,
        };
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMinor]);

  /**********************************************************************************
   * ISMINOR: Comprobar si el usuario es menor de edad
   **********************************************************************************/
  const handleIsMinor = (isMinor: boolean) => {
    if (isMinor) {
      setFinancialForm((prevState: any) => {
        return {
          ...prevState,
          economicActivity: true,
          proofOfIncome: true,
          gafiQuestion: true,
          publicPosition: true,
          maxContribution: true,
        };
      });
      setShowFinancialForm(false);
      removeClaimMessage("economicActivity");
      removeClaimMessage("proofOfIncome");
    } else {
      // setShowFinancialForm(true);
    }
  };

  const handleFiscalAddressAccountHolderDataChange = (event: any) => {
    let { name, value }: { name: string; value: string } = event.target;
    const realName = name.startsWith("fiscal_") ? name.slice(7) : name;
    let realValue = value;
    if (
      event.target.files !== null &&
      event.target.files !== undefined &&
      event.target.files.length > 0
    ) {
      realValue = event.target.files[0];
    }
    setUserIdentity((prevState: any) => ({
      ...prevState,
      fiscalAddress: {
        ...prevState.fiscalAddress,
        [realName]: realValue,
      },
    }));
  };

  /**********************************************************************************
   * BOTÓN DE ENVÍO: Comprobar si se puede enviar el formulario
   **********************************************************************************/
  const btnSubmit = useCallback(() => {
    userIdentityForm.birthday = true;
    const result = Object.values(userIdentityForm).every((ob) => ob === true);
    setCanSubmit(result);
  }, [userIdentityForm]);

  useEffect(() => {
    btnSubmit();
  }, [btnSubmit]);

  // ------------------------------
  // ACTUALIZAR USER IDENTITY FORM
  // ------------------------------
  const updateUserIdentityForm = (name: string, value: any) => {
    if (userIdentityForm[name] !== value) {
      userIdentityForm[name] = value;
      setUserIdentityForm(userIdentityForm);
      btnSubmit();
    }
  };

  // useEffect(() => {
  //     console.log('>>¿¿userIdentityForm>>> ', userIdentityForm);
  // }, [userIdentityForm]);

  // useEffect(() => {
  //     console.log('>>>¿¿financialUserIdentity >>> ', financialUserIdentity);
  // }, [financialUserIdentity]);

  // useEffect(() => {
  //     console.log('>>>¿financialForm actualizado >>> ', financialForm);
  // }, [financialForm]);

  // ------------------------------
  // ACTUALIZAR USER IDENTITY FORM
  // ------------------------------
  const updateFinancialForm = (name: string, value: any) => {
    setFinancialForm((prev: any) => {
      if (prev[name] !== value) {
        return {
          ...prev,
          [name]: value,
        };
      }
      return prev;
    });
  };

  useEffect(() => {
    if (!isMinor) {
      const allFinancialFormIsValid =
        financialUserIdentity.economicActivity &&
        financialUserIdentity.proofOfIncome &&
        financialUserIdentity.gafiQuestion === false &&
        financialUserIdentity.maxContribution >= 0 &&
        financialUserIdentity.publicPosition === false;

      if (allFinancialFormIsValid) {
        console.log("✅ Datos financieros completos y válidos");
        setUserIdentity((prevState: any) => ({
          ...prevState,
          gafiQuestion: financialUserIdentity.gafiQuestion,
          economicActivity: financialUserIdentity.economicActivity,
          publicPosition: financialUserIdentity.publicPosition,
          proofOfIncome: financialUserIdentity.proofOfIncome,
          maxContribution: financialUserIdentity.maxContribution,
        }));

        setUserIdentityForm((prevState: any) => ({
          ...prevState,
          financialData: true,
        }));
      } else {
        setUserIdentityForm((prevState: any) => ({
          ...prevState,
          financialData: false,
        }));
        console.log("X Datos financieros incompletos e inválidos");
      }
    } else {
      setUserIdentityForm((prevState: any) => ({
        ...prevState,
        financialData: true,
        gafiQuestion: true,
        publicPosition: true,
        economicActivity: true,
        proofOfIncome: false || userIdentity.proofOfIncome !== null,
        maxContribution: true,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [financialUserIdentity, isMinor]);

  // ----------------------------------------------
  // ACTUALIZAR USER IDENTITY document intelligence
  // ----------------------------------------------
  const updateWithIntelligence = (updatedData: any) => {
    setUserIdentity((prevState: any) => ({
      ...prevState,
      ...updatedData,
    }));

    // mostrar el formulario financiero si no es menor de edad
    if (!isMinor) {
      setShowFinancialForm(true);
    }
    setDocumentLoaded(true);

    addClaimMessage({
      id: "intelligence-update-success",
      type: "success",
      message:
        "Lectura de documentos completada con éxito. Completa el resto de campos obligatorios del formulario y guarda los cambios.",
    });
  };

  useEffect(() => {
    // bloquear el formulario si hay algún aviso de autorización
    if (showAuthorizationWarning) {
      // setIsOnlyView(false);
      setBlockedByAuthorizationWaring(true);
    }
  }, [showAuthorizationWarning]);

  // ---------------------------------------------------------------------------------
  // ACCESS-REQUEST: Pedir autorización al usuario-receptor
  // ---------------------------------------------------------------------------------
  const requestAuthorization = () => {
    setIsSendingAuthorization(true);
    setAuthorizationWarningMessage(DEFATULT_WARNING_MESSAGE);
    setShowAuthorizationButton(true); // Reset botón

    if (userIdentityByIdDocument?.id !== undefined) {
      UserIdentitiesService.postUserIdentityAccessRequest(
        user.id,
        userIdentityByIdDocument.id,
        userIdentityByIdDocument.userId!
      )
        .then((accessRequestResponse: UserIdentityAccessRequest) => {
          if (accessRequestResponse !== null) {
            history.push(`/accountHolder/${savingsPlanId}`);
          }
        })
        .catch((error) => {
          console.log("error", error);

          // Si el backend devuelve un mensaje de error específico
          const backendMessage = error?.response?.data?.message;
          if (backendMessage) {
            setAuthorizationWarningMessage(backendMessage);
          } else {
            setAuthorizationWarningMessage(
              "Ha ocurrido un error al solicitar la autorización."
            );
          }

          setShowAuthorizationButton(false);
        })
        .finally(() => {
          setIsSendingAuthorization(false);
        });
    } else {
      setAuthorizationWarningMessage(
        "No se ha podido enviar la solicitud de autorización"
      );
      setShowAuthorizationButton(false);
      setIsSendingAuthorization(false);
    }
  };

  // ---------------------------------------------------------------------------------
  // ACCESS-REQUEST: Mostrar/ocultar el aviso de autorización
  // ---------------------------------------------------------------------------------
  const handleShowAuthorizationWarning = (
    show: boolean,
    queriedUserIdentityByIdDocument: UserIdentityType,
    errorMessage: string,
    showButton: boolean
  ) => {
    setShowAuthorizationWarning(false);
    setShowAuthorizationWarning(show);
    setShowAuthorizationButton(showButton);
    if (queriedUserIdentityByIdDocument !== null) {
      setUserIdentityByIdDocument(queriedUserIdentityByIdDocument);
    }
    if (errorMessage !== undefined && errorMessage !== null) {
      setAuthorizationWarningMessage(errorMessage);
    }
  };

  const getAMLVerification = async (
    userIdentityId: number,
    idDocument: string,
    mode: string
  ) => {
    setSending(true);
    try {
      const response: any = await UserIdentitiesService.AMLVerification(
        userIdentityId,
        idDocument
      );
      const successMessage =
        mode === "create"
          ? "El interviniente ha sido creado correctamente. Redirigiendo al listado de intervinientes... Espere."
          : "El interviniente ha sido actualizado correctamente. Redirigiendo al listado de intervinientes... Espere.";

      if (response && response.status === 200) {
        onHandleFinancialClaimMessage({
          id: "aml-verification-success",
          type: "success",
          message: successMessage,
        });
        // Deshabilitar el botón de envío y redirección
        setCanSubmit(false);
        setTimeout(() => {
          history.push(`/accountHolder/${savingsPlanId}`);
        }, 3000);
      } else {
        onHandleFinancialClaimMessage({
          id: "aml-verification-error",
          type: "error",
          message:
            response.message ||
            "La verificación del documento ha fallado. Por favor, inténtelo de nuevo más tarde.",
        });
      }
    } catch (error: any) {
      console.error("AMLVerification error >>> ", error);

      if (error.response && error.response.status === 422) {
        onHandleFinancialClaimMessage({
          id: "aml-verification-error-422",
          type: "error",
          message:
            error.response.data?.message || "Usuario rechazado por PEP/AML.",
        });
      } else {
        onHandleFinancialClaimMessage({
          id: "aml-verification-catch-error",
          type: "error",
          message:
            error.message ||
            "Ha ocurrido un error al realizar la verificación del documento. Por favor, inténtelo de nuevo más tarde.",
        });
      }
    } finally {
      setSending(false);
    }
  };

  // --------------------------------------------------------------------------
  // nextportfolio: Comprobar si el idDocument no existe en nuestra base de datos, pero ya existe en finametrix
  // --------------------------------------------------------------------------
  const checkIdDocumentOnNextPortfolio = async (
    userIdentity: UserIdentityType
  ): Promise<string | null> => {
    if (userIdentity.idDocument) {
      const auxIdDocument = userIdentity.idDocument.trim();
      try {
        const userIdentityByIdDocument: UserIdentityType =
          await UserIdentitiesService.getUSerIdentityByIdDocument(
            auxIdDocument
          );
        if (!userIdentityByIdDocument) {
          const finametrixClient =
            await FinametrixService.getClientByIdCardNoValidation(
              auxIdDocument
            );
          if (finametrixClient && finametrixClient._id) {
            console.log("Cliente encontrado en Finametrix:", finametrixClient);
            return finametrixClient._id;
          } else {
            console.log(
              "Cliente no encontrado en Finametrix, permitiendo alta sin id"
            );
          }
        }
      } catch (error) {
        console.error(
          "Error en la búsqueda de Finametrix por idDocument:",
          error
        );
      }
    }
    return null;
  };

  const handleSubmit = async () => {
    console.log("handleSubmit USERIDENTITY >>> ", userIdentity);
    if (userIdentity !== undefined) {
      setSending(true);

      if (userIdentity.phone.startsWith(userIdentity.countryPrefix)) {
        userIdentity.phone = userIdentity.phone.replace(
          userIdentity.countryPrefix,
          ""
        );
      }

      if (
        userIdentity.operationPhone.startsWith(
          userIdentity.operationCountryPrefix
        )
      ) {
        userIdentity.operationPhone = userIdentity.operationPhone.replace(
          userIdentity.operationCountryPrefix,
          ""
        );
      }

      userIdentity.signPhone = userIdentity.phone;
      userIdentity.signCountryPrefix = userIdentity.countryPrefix;
      if (
        userIdentity.signPhone === undefined ||
        userIdentity.signPhone === null ||
        userIdentity.signPhone.trim() === ""
      ) {
        userIdentity.signPhone = userIdentity.phone;
        userIdentity.signCountryPrefix = userIdentity.countryPrefix;
      }

      // Comprobar si el idDocument no existe en nuestra base de datos, pero ya existe en finametrix
      const finametrixId = await checkIdDocumentOnNextPortfolio(userIdentity);
      if (finametrixId) {
        userIdentity.finametrixId = finametrixId;
      }

      console.log("userIdentity PARA ENVIAR >>> ", userIdentity);
      if (userIdentity.id !== undefined) {
        if (user.status === "4000") {
          userIdentity.status = UserIndentityStatusEnum.Active;
        }

        UserIdentitiesService.updateUserIdentity(userIdentity).then(
          (updatedUserIdentity: UserIdentityType) => {
            // AML verification
            if (
              updatedUserIdentity.id !== undefined &&
              updatedUserIdentity.idDocument !== undefined
            ) {
              // AML redirige en caso de éxito al listado de intervinientes
              getAMLVerification(
                updatedUserIdentity.id,
                updatedUserIdentity.idDocument,
                "update"
              );
            } else {
              setSending(false);
              handleClaimMessage({
                id: "user-identity-update-unkown-error",
                type: "error",
                message:
                  "Ha ocurrido un error en la actualización del interviniente. Por favor, inténtelo de nuevo más tarde o póngase en contacto con soporte a través del botón ¿Necesitas asistencia?.",
              });
            }
          },
          (error: any) => {
            setError(error);
            handleClaimMessage({
              id: "user-identity-update-error",
              type: "error",
              message: "No se ha podido actualizar el interviniente",
            });
            setSending(false);
          }
        );
      } else {
        const utcBirthday = new Date(
          Date.UTC(
            userIdentity.birthday.getFullYear(),
            userIdentity.birthday.getMonth(),
            userIdentity.birthday.getDate()
          )
        );
        const utcIdExpiration = new Date(
          Date.UTC(
            userIdentity.idExpiration.getFullYear(),
            userIdentity.idExpiration.getMonth(),
            userIdentity.idExpiration.getDate()
          )
        );

        userIdentity.birthday = utcBirthday;
        userIdentity.idExpiration = utcIdExpiration;

        UserIdentitiesService.createUserIdentity(userIdentity).then(
          (storedUserIdentityAux: UserIdentityType) => {
            // AML verification
            if (
              storedUserIdentityAux.id !== undefined &&
              storedUserIdentityAux.idDocument !== undefined
            ) {
              // AML redirige en caso de éxito al listado de intervinientes
              getAMLVerification(
                storedUserIdentityAux.id,
                storedUserIdentityAux.idDocument,
                "create"
              );
            }
          },
          (error: any) => {
            // Capturar el error del backend
            let message =
              "Se ha producido un error que impide continuar con el proceso.";

            // Verificar si el error tiene una respuesta (error.response) y si contiene un mensaje de error
            if (
              error.response &&
              error.response.data &&
              error.response.data.errorMessage
            ) {
              message += ` ${error.response.data.errorMessage}`;
            }

            // Mostrar el mensaje de error con el estado en falso
            setError({ status: false, message });
          }
        );
      }
    }
  };

  return (
    <DocumentTitle title={`IronIA - Editar Interviniente`}>
      <React.Fragment>
        <S.HelperStyle />
        <S.Cont theme={theme}>
          <S.MainCont className="convenienceTestAccountHolderData-main-container">
            <S.StickyHeaderContainer
              isSticky={isSticky}
              showSupportForm={showSupportForm}
              theme={theme}
              className="ms-Grid-row sm-12 md-12 lg-12 xl-12"
            >
              <S.SupportContainer>
                <TicketSupport
                  showSupportForm={showSupportForm}
                  setShowSupportForm={setShowSupportForm}
                  onSupportSend={handleSupportSend}
                  component="ConvenienceTestAccountHolderData"
                  savingPlanId={savingsPlanId}
                  screenName={SCREEN_NAME}
                  userIdentity={userIdentity}
                  formVal={userIdentityForm}
                  financialFormVal={financialForm}
                />
                {!showSupportForm && (
                  <S.SupportBtnCont>
                    {!isOnlyView && (
                      <React.Fragment>
                        <DefaultButton
                          type="submit"
                          onClick={() =>
                            history.push(`/accountHolder/${savingsPlanId}`)
                          }
                          disabled={!isLoadedUserIdentity}
                          className="button tiny-primary-button"
                          style={{ marginTop: "0px !important" }}
                        >
                          Cancelar
                        </DefaultButton>
                        <DefaultButton
                          type="submit"
                          onClick={() => handleSubmit()}
                          disabled={
                            !isLoadedUserIdentity || sending || !canSubmit
                          }
                          className="button tiny-primary-button"
                          style={{ marginTop: "0px !important" }}
                        >
                          {sending && (
                            <Spinner
                              size={SpinnerSize.small}
                              className="button-spinner"
                            />
                          )}
                          Guardar
                        </DefaultButton>
                      </React.Fragment>
                    )}
                  </S.SupportBtnCont>
                )}
              </S.SupportContainer>
              {claimMessages.length > 0 && (
                <S.ClaimErrors>
                  {claimMessages.map((claim) => (
                    <ClaimMessage
                      key={claim.id}
                      type={claim.type}
                      message={claim.message}
                      onClose={() => removeClaimMessage(claim.id)}
                    />
                  ))}
                </S.ClaimErrors>
              )}
            </S.StickyHeaderContainer>
            <S.Title
              className="sm-12 md-12 lg-12 xl-12"
              style={{ width: "100%" }}
            >
              <h1>Información Personal Interviniente</h1>
              <h2>
                Selecciona los documentos de tu identificación y pulsa procesar.
                No olvides completar todos los campos con *.
              </h2>
              {showAuthorizationWarning && (
                <S.WarningIdExists>
                  <S.WarningIdExistsMessage>
                    {authorizationWarningMessage}
                  </S.WarningIdExistsMessage>
                  {showAuthorizationButton && (
                    <DefaultButton
                      className="button tiny-primary-button warning-send-button"
                      onClick={requestAuthorization}
                      disabled={isSendingAuthorization}
                    >
                      {isSendingAuthorization && (
                        <Spinner
                          size={SpinnerSize.small}
                          className="button-spinner"
                        />
                      )}
                      Enviar autorización
                    </DefaultButton>
                  )}
                </S.WarningIdExists>
              )}
            </S.Title>
            <S.TabletCont theme={theme} className="holderData-table-container">
              {!isLoadedUserIdentity && <Spinner size={SpinnerSize.large} />}
              {isLoadedUserIdentity && (
                <React.Fragment>
                  <ConvenienceTestAccountHolderDataInputs
                    onProcessingDocument={(event: any) =>
                      setIsLoadedUserIdentity(event)
                    }
                    isOnlyView={isOnlyView}
                    blockedByAuthorizationWarning={
                      blockedByAuthorizationWarning
                    }
                    isNewUserIdentity={isNewUserIdentity}
                    data={userIdentity}
                    userIdentities={userIdentities}
                    handleChange={(event: any) =>
                      handleAccountHolderDataChange(event)
                    }
                    handlePostalAddrChange={(event: any) =>
                      handlePostalAddressAccountHolderDataChange(event)
                    }
                    handleFiscalAddrChange={(event: any) =>
                      handleFiscalAddressAccountHolderDataChange(event)
                    }
                    handleSameAddressChange={(event: any) =>
                      handleAccountHolderSameAddressChange(event)
                    }
                    handleIsMinor={handleIsMinor}
                    updateIntelligenceUserIdentity={updateWithIntelligence}
                    formVal={userIdentityForm}
                    handleClaimMessage={handleClaimMessage}
                    handleShowAuthorizationWarning={
                      handleShowAuthorizationWarning
                    }
                    setFormVal={(name: string, value: any) =>
                      updateUserIdentityForm(name, value)
                    }
                  />
                </React.Fragment>
              )}
            </S.TabletCont>
            {/* Información financiera */}
            {showFinancialForm && (
              <S.FinancialInfo theme={theme}>
                <S.Title>
                  <h1>Información Financiera Interviniente</h1>
                  <h2>
                    Selecciona un documento que justifique los ingresos. Con
                    este documento se calculará el importe de la inversión
                    justificada. Este dato es imprescindible para la lucha
                    contra el blanqueo de capitales.
                  </h2>
                </S.Title>
                <S.TabletCont
                  theme={theme}
                  className="holderData-table-container"
                >
                  <FinancialData
                    handleFinancialChange={(event: any) =>
                      handleFinancialDataChange(event)
                    }
                    blockedByAuthorizationWarning={
                      blockedByAuthorizationWarning
                    }
                    userIdentity={userIdentity}
                    data={financialUserIdentity}
                    jobs={jobs}
                    birthdate={userIdentity.birthday}
                    financialFormVal={financialForm}
                    setFinancialFormVal={(name: string, value: any) =>
                      updateFinancialForm(name, value)
                    }
                    isCalculatedMaxContribution={(value: boolean) => {
                      setCanSubmit(value);
                    }}
                    handleCreateFinancialClaimMessage={
                      onHandleFinancialClaimMessage
                    }
                  />
                </S.TabletCont>
              </S.FinancialInfo>
            )}
            {error.message !== "" && (
              <S.TabletCont theme={theme}>
                <S.Error>{error.message}</S.Error>
              </S.TabletCont>
            )}
            {/* Modal de confirmación */}
            <ModalWithCancel
              showModal={showModal}
              setShowModal={setShowModal}
              title={modalTitle}
              body={modalBody}
              onClose={() => setShowModal(false)}
              btnSubmitText="Cerrar"
            />
          </S.MainCont>
        </S.Cont>
      </React.Fragment>
    </DocumentTitle>
  );
};

export default ConvenienceTestAccountHolderData;
